module.exports = __webpack_public_path__ + "img/11.362a78fe.png";